import React, { Component } from 'react';
import { Router, IndexRoute, Route } from 'react-router';

const ExerciseMultipleAnswers = React.createClass({
    render() {
        return(
            <div className="exercise-multipleAnswer-wrap">
                <div className="exercise-multipleAnswer">
                    {this.props.children}
                </div>
            </div>
        );
    }
});

export default ExerciseMultipleAnswers;


/** WEBPACK FOOTER **
 ** ./src/components/ExerciseMultipleAnswers/ExerciseMultipleAnswers.js
 **/